export const formatDate = (dateString, locale = 'en-US') => {
  if (!dateString) return;
  const date = new Date(dateString);

  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateDDMMYY = (dateString) => {
  if (!dateString) return;

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());

  return `${day}-${month}-${year}`;
};
export const getInitials = (name) => {
  if (!name) return '?';
  const words = name.trim().split(' ');
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

export const getAvatarColor = (userId) => {
  const colors = [
    '#FF6B6B',
    '#4ECDC4',
    '#45B7D1',
    '#FFA07A',
    '#98D8C8',
    '#F7DC6F',
    '#BB8FCE',
    '#85C1E2',
    '#F8B195',
    '#6C5CE7',
    '#A29BFE',
    '#FD79A8',
  ];
  return colors[userId % colors.length];
};
export const formatAmount = (amount, locale = 'en-US') => {
  if (amount === null || amount === undefined) return;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'OMR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatDecimal = (amount, lang = 'en') => {
  const locale = lang === 'ar' ? 'ar-OM' : 'en-US';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatNumber = (number, locale = 'en-US') => {
  if (number === null || number === undefined) return '';

  return new Intl.NumberFormat(locale, {
    useGrouping: false, // disables thousands separator
    maximumFractionDigits: 2,
  }).format(number);
};

export const formatTons = (kg, decimals = 2) => {
  if (!kg || isNaN(kg)) return '0.00';
  return (kg / 1000).toFixed(decimals);
};

export const formatWeight = (weight) => {
  if (!weight) return '0';
  // Remove commas and convert to number
  const numWeight = typeof weight === 'string' ? parseFloat(weight.replace(/,/g, '')) : weight;

  if (numWeight >= 1000) {
    return (numWeight / 1000).toFixed(1);
  }
  return numWeight.toLocaleString();
};

export const fmt = (n) => Math.abs(n).toLocaleString('en-US');

export const C = {
  teal: '#1b8f9b',
  tealMid: '#3aacb8',
  red: '#e05252',
  amber: '#c47f17',
  lime: '#bdc432',
  ink: '#1a2a2b',
  label: '#7a9496',
  border: 'rgba(0,0,0,0.07)',
};

export function openBlobInNewTab(blob, revokeDelay = 5000) {
  const objectUrl = URL.createObjectURL(blob);

  const anchor = Object.assign(document.createElement('a'), {
    href: objectUrl,
    target: '_blank',
    rel: 'noopener noreferrer',
  });

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  setTimeout(() => URL.revokeObjectURL(objectUrl), revokeDelay);
}
